import React, {useImperativeHandle, useState, useRef, forwardRef, useContext, useEffect} from "react";

import {View, Text}  from 'react-native';

import {estilos} from '../util/estilos'

import * as numeros from '../util/numeros'

import Botao from '../componentes/Botao'

import * as util from '../util/util'

import {remover as wsRemover, anunciar as wsAnunciar} from '../ws/ws_itens'

import FormularioPesquisa from '../componentes/FormularioPesquisa'

import {buscarItens} from '../ws/ws_itens'

import contexto from '../util/contexto'

import cores from '../util/cores'

import {ITEM_ANUNCIO_ATIVO, ITEM_ANUNCIO_INATIVO, ITEM_ATIVO, 
	TELA_BUSCAR_ITENS, TELA_DETALHE_ITEM} from '../util/constantes'

import * as data from '../util/data'

import Imagem from '../componentes/Imagem'

import Scroll from '../componentes/Scroll'

import Bloco from '../componentes/Bloco'

import {useNavigation} from '@react-navigation/native'

import Alerta from '../componentes/Alerta'

import Combo from '../componentes/Combo'


export const TIPO_GESTAO_ITEM = 7;
export const TIPO_SELECAO_ITEM = 17;
export const TIPO_ANUNCIO_ITEM = 27;
export const TIPO_BUSCAR_ITEM = 37;
export const TIPO_LOJA_ITEM = 47;


const FormularioSelecionarItem = forwardRef((props, ref) => {

	const {valorContexto, setValorContexto} = useContext(contexto);

	const [situacaoAnuncio, setSituacaoAnuncio] = useState(props.tipo == TIPO_ANUNCIO_ITEM?ITEM_ANUNCIO_ATIVO:null) 
	
	const navegacao = new useNavigation();

	const formularioPesquisaRef  = useRef(null)
	
	
	const idUsuario = props.tipo == TIPO_LOJA_ITEM?valorContexto.idUsuarioAtual:props.idUsuario;


	useImperativeHandle(ref, () => ({}));


	const buscarDados= async (termos)=>{
	
		let retorno  = props.tipo == TIPO_BUSCAR_ITEM?
						await buscarItens(null, termos, ITEM_ATIVO,
											ITEM_ANUNCIO_ATIVO, formularioPesquisaRef.current.getIndex()):
						props.tipo == TIPO_LOJA_ITEM?
							await buscarItens(idUsuario!=null?parseInt(idUsuario):null, termos, ITEM_ATIVO, 
											ITEM_ANUNCIO_ATIVO, formularioPesquisaRef.current.getIndex()):
							await buscarItens(idUsuario!=null?parseInt(idUsuario):null, termos, ITEM_ATIVO, 
											situacaoAnuncio, formularioPesquisaRef.current.getIndex());
   
		return util.temConteudo(retorno)?retorno:[]
	}


	const preparaParaRemover= async (item)=>{
	
		util.print("preparaParaRemover "+item.id);
		
		Alerta("Exclusão de Item", "Deseja realmente excluir este Item?", async ()=>{
			await remover(item.id);
		})
	}


	const remover= async (id)=>{
	
		util.print("remover "+id);
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.sincronizando();
		
		await wsRemover(id);
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.pesquisar();
	}

	
	const anunciar= async (item)=>{
	
		util.print("anunciar "+item.id);
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.sincronizando();
		
		await wsAnunciar(item.id);
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.pesquisar();
	}


	const verItem= async (item)=>{

		console.log("verItem "+item.id);
		
		setValorContexto(prevState =>({...prevState, idItem: item.id}));

		if(props.tipo == TIPO_GESTAO_ITEM)

		util.setVoltar(props.voltarPara);
		
		navegacao.navigate(TELA_DETALHE_ITEM)
	}


	useEffect(() => {
		
		util.print("FormularioSelecionarItem atualizando")
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.pesquisar();
  
	}, []); 
	
	
	function getOpcoesItem(item){
		
		if(props.tipo == TIPO_GESTAO_ITEM)
			return(
				(<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Botao
								acao={()=>props.verItem(item)}
								texto="detalhar"
								somente_texto={true}
								cor={cores.azul}/> 
						</View>
						
					<View style={estilos.coluna}/> 
						
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						<Botao
							acao={()=>preparaParaRemover(item)}
							texto="Excluir"
							somente_texto={true}
							cor={cores.vermelho}/> 
					</View>
				</View>)	
			)
			
		if(props.tipo == TIPO_SELECAO_ITEM)
			return(
				<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
					<Botao
						acao={()=>props.selecionar(item)}
						texto="Selecionar"
						somente_texto={true}/> 
				</View>
			)		
		
		if(props.tipo == TIPO_ANUNCIO_ITEM){

			if (item.anunciado==null || item.anunciado<=0)
				return(
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						<Botao
							acao={()=>anunciar(item)}
							texto="Anunciar"
							somente_texto={true}/> 
					</View>
				)
			else
				return(
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						<Text style={estilos.rotulo_menor}>Ativado em: {data.converteDataEuaParaBr(item.data_anuncio)}</Text>
					</View>
				)
		}
		
		if(props.tipo == TIPO_BUSCAR_ITEM || props.tipo == TIPO_LOJA_ITEM)
			return(
				<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
					<Botao
						acao={()=>verItem(item)}
						texto="Detalhar"
						somente_texto={true}/> 
				</View>
			)
		
		return (<View></View>)
	}
	
	
	function itemLista(item){

		return (
			<Bloco> 
				<View style={{marginTop:5}}/>
				<View style={estilos.grade}>
					<View> 
						<Imagem imagem={item.imagem} tamanho={80}/>
					</View> 
					<View style={estilos.coluna}> 
						<View style={{marginTop:10}}/>
						<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
						<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 60)}</Text>
						<Text style={estilos.rotulo_titulo}>{util.temConteudo(item.valor)?'R$: '+numeros.formataNumeroParaMostrar(item.valor):''}</Text>
					</View>
				</View>
				<View style={{marginTop:10}}/>
				{getOpcoesItem(item)}
				<View style={{marginTop:5}}/>
			</Bloco>
		)
	}
	
	
	function filtrosPesquisa(){
		
		if(props.tipo == TIPO_ANUNCIO_ITEM){
			
			let dados = [{'id': ITEM_ANUNCIO_ATIVO, 'nome': "Anunciados"}, 
				{'id': ITEM_ANUNCIO_INATIVO, 'nome': "Não Anunciados"}];
				
			return(
				<View>
					<View style={{marginTop:10}}/>  
					<View style={estilos.grade}>
						<View style={estilos.coluna_dupla}> 
							<Combo 
								mostrarVazio = {false}
								rotulo="Situação do Anúncio:"
								dados={dados} 
								aoMudar={(valor)=>setSituacaoAnuncio(valor.id)}
								selecionado={situacaoAnuncio}/>
						</View>
						<View style={estilos.coluna}/> 
					</View> 
					<View style={{marginTop:10}}/>  
				</View>
			)
		}

		return (<View></View>)
	}
	
	
	return (
		<View style={{flex:1}}>  	           
			<Scroll> 
				<View style={{flex:1}}>  	      
					{props.topo}
					<FormularioPesquisa 
						ref={formularioPesquisaRef} 
						pesquisar={buscarDados}
						componentes={filtrosPesquisa()}
						msgSemDados={props.tipo == TIPO_LOJA_ITEM?"Esta loja ainda não possui produtos/serviços.":
															"Nenhum produtos/serviços cadastrado."}
						itemLista={(item)=>itemLista(item)}>
						
						{props.tipo == TIPO_GESTAO_ITEM && 
							<View style={{alignItems:'center'}}>
								<Botao 
									acao={()=>props.novoItem()}
									texto="Novo Produto/Serviço"/> 
								<View style={{marginTop:10}}/>	
							</View>
						}
					</FormularioPesquisa>	
				</View>
			</Scroll>     
		</View>
	);
});


export default FormularioSelecionarItem;
